export const ENDPOINTS = {
  getCalendar: '/gateway/extranet/:hotelId/calendars/:calendarId',
  createSlot: '/gateway/extranet/:hotelId/calendars/:calendarId/slots',
  updateSlot: '/gateway/extranet/:hotelId/calendars/:calendarId/slots/:slotId',
  validateUpdateSlot:
    '/gateway/extranet/:hotelId/calendars/:calendarId/slots/:slotId/validate',
  deleteSlot: '/gateway/extranet/:hotelId/calendars/:calendarId/slots/:slotId',
  createSeries: '/gateway/extranet/:hotelId/calendars/:calendarId/series',
  validateCreateSeries:
    '/gateway/extranet/:hotelId/calendars/:calendarId/series/validate',
  updateSeries:
    '/gateway/extranet/:hotelId/calendars/:calendarId/series/:seriesId',
  validateUpdateSeries:
    '/gateway/extranet/:hotelId/calendars/:calendarId/series/:seriesId/validate',
  deleteSeries:
    '/gateway/extranet/:hotelId/calendars/:calendarId/series/:seriesId',
} as const;

export const CORE_QUERY_KEYS = {
  calendar: 'extranet-calendar',
} as const;
